@use '@fpsm/cxy-scss' as cxy;

.formRefinementContainer {
  @include cxy.stack(var(--cxy-spacing-2));
}

.label {
  font-size: var(--cxy-fontSize-s);
  margin-top: var(--cxy-spacing-2);
}

.resetButton {
  align-self: center;
}
